import Users from "./Users";

const ResellerAllUsers = () => {
  return (
    <div>
      <Users
        userCat={"All"}
        addUserCTA="Create a User Account"
        userPageTitle="All Users"
      />
    </div>
  );
};

export default ResellerAllUsers;
